'use strict';

class ChallengesWeatherController {
  constructor($q,
              $scope,
              $compile,
              $filter,
              $state,
              utils,
              config,
              NgMap,
              NavigatorGeolocation,
              UsersService,
              GoogleMapsService,
              DevicesService,
              ChallengesService,
              TagsService,
              ToastsService,
              I18nService) {

    const $t = $filter('translate');
    const locale = I18nService.getLocale()?.code || 'en';
    const CURRENT_ORG_LOCAL_STORAGE_KEY = 'Organizations-Current';

    $scope.monthFormat = $t('datetime.challenges.month');
    $scope.dateFormat = $t('datetime.challenges.date');

    $scope.orgInfo = utils.getStorageItem(CURRENT_ORG_LOCAL_STORAGE_KEY);
    $scope.challengeId = $state.params && $state.params.id;

    $scope.optInStatuses = config.getConfigByKey('optInStatuses');
    $scope.savingsLevels = config.getConfigByKey('savingsLevels');
    $scope.deviceTypeExistance = config.getConfigByKey('deviceTypeExistance');
    $scope.thermostats = config.getConfigByKey('thermostats');

    $scope.compireRadios = function() {
      $compile($('#typeExistanceRadioList .ui.radio'))($scope);
      $('#typeExistanceRadioList .ui.radio').checkbox({
        onChange: function() {
          $scope.deviceTypeExistanceId = this.value;
        }
      });
    };

    function getPopularTags() {
      return TagsService.getPopularTags($scope.orgInfo.id, 2)
        .then(function(data) {
          $scope.locationTags = data.tags;
          return data;
        });
    }

    getPopularTags();

    GoogleMapsService.getGoogleMapsUrl()
      .then((googleMapsUrl) => {
        $scope.googleMapsUrl = googleMapsUrl;
      });

    //Start WDR Map stuff
    let initWeatherDemandResponse = function() {
      if ($scope.updateWeatherSourceFromMap) {
        return;
      } //we are already initialised

      //Initialize map stuff
      let setMarkerPosition = function(lat, lng) {
        $scope.latitude = lat;
        $scope.longitude = lng;
      };
      let updateMapCenter = function() {
        NgMap.getMap().then(function(map) {
          map.setCenter({ lat: Number($scope.latitude), lng: Number($scope.longitude) });
        });
      };
      // Initialize map stuff (Cape Cod, US by default)
      $scope.defaultMapCenter = [$scope.latitude || 41.66891793099595, $scope.longitude || -70.29606913862301];
      $scope.updateWeatherSourceFromMap = function(e) {
        setMarkerPosition(e.latLng.lat(), e.latLng.lng());
      };
      $scope.updateWeatherSourceFromMapAutocomplete = function() {
        let location = this.getPlace().geometry.location;
        setMarkerPosition(location.lat(), location.lng());
        updateMapCenter();
      };

      //If WDR Challenge has no latlng stored, then - try to get current user's position to center the map there
      if (!$scope.latitude || !$scope.longitude) {
        NavigatorGeolocation.getCurrentPosition()
          .then(function(position) {
            if (position && position.coords) {
              setMarkerPosition(position.coords.latitude, position.coords.longitude);
            } else {
              setMarkerPosition.apply(this, $scope.defaultMapCenter);
            }
          }, function(rejected) {
            setMarkerPosition.apply(this, $scope.defaultMapCenter);
          }).then(function() {
          updateMapCenter();
        });
      }
      //In order for the map to render tiles, we need to trigger resize event, since the map wasn't visible before
      NgMap.getMap().then(function(map) {
        //Tell map to incorporate search inputbox inside itself
        map.controls[google.maps.ControlPosition.TOP_LEFT].push($('#wdrMapAutocomplete')[0]);
        google.maps.event.trigger(map, 'resize');
        updateMapCenter();
      });
    };
    //End WDR Map stuff

    let currentDate = new Date();
    let currentMonthDate = new Date(currentDate.getFullYear(), currentDate.getMonth(), 1);
    let nextMonthDate = utils.nextMonth(currentDate);

    $('.tabular.menu .item').tab({
      'onVisible': function(tabPath) {
        initTabs(tabPath);
      }
    });
    let initTabs = function(tabName) {
      if (tabName == 'events') {
        $('#div-buttons').hide();
      } else if (tabName === 'weather') {
        $scope.$watch('longitude', function() { initWeatherDemandResponse(); });
      } else {
        $('#div-buttons').show();
      }
      $state.go($state.current.name, { tab: tabName }, {
        location: true,
        notify: false,
        reload: false
      });
    };
    let tabName = $state.params && $state.params.tab;
    if (tabName) {
      $('.tabular.menu .item').tab('change tab', tabName);
    }

    let initDatePicker = function() {
      $scope.datePickerOptions = {
        language: locale,
        position: 'top left',
        view: 'days',
        minView: 'days',
        dateFormat: 'm/dd/yyyy ',
        timepicker: true,
        autoClose: false,
        minDate: new Date()
      };
    };

    initDatePicker();

    $scope.deleteChallenge = function() {
      return ChallengesService
        .deleteChallenge($scope.orgInfo.id, $scope.challengeId)
        .then(data => {
          $state.go('main.challenges.list');
          return data;
        });
    };

    $scope.changeStatus = function(value) {
      return ChallengesService
        .updateChallengeStatus($scope.orgInfo.id, $scope.challengeId, value)
        .then(data => {
          $scope.challenge.status = value;
          return data;
        });
    };

    //save challenge
    let dateCompareRule = function(value) {
      if ($scope.challenge.endDateMs && $scope.challenge.startDateMs) {
        return $scope.challenge.endDateMs - $scope.challenge.startDateMs > 0;
      }
      return false;
    };
    let datepickerRule = function(value) {
      if (!value || value == '') {
        return false;
      }
      return true;
    };
    $.fn.form.settings.rules.startDateRule = function(value) {
      return datepickerRule(value);
    };
    $.fn.form.settings.rules.endDateRule = function(value) {
      return datepickerRule(value);
    };
    $.fn.form.settings.rules.startTimeRule = function(value) {
      return value.match(timeRegExp);
    };
    $.fn.form.settings.rules.endTimeRule = function(value) {
      return value.match(timeRegExp);
    };
    $.fn.form.settings.rules.participationStatusRule = function(value) {
      if (value == null || value == '') {
        return false;
      } else {
        return true;
      }
    };
    $.fn.form.settings.rules.deviceTypesRule = function(value) {
      if (value == null || value == '') {
        return false;
      } else {
        return true;
      }
    };
    $.fn.form.settings.rules.percentageRule = function(value) {
      if (value < 1 || value > 100) {
        return false;
      } else {
        return true;
      }
    };
    $.fn.form.settings.rules.number = function(value) {
      return !isNaN(parseFloat(value)) && isFinite(value);
    };
    $.fn.form.settings.rules.coordinates = function(value, n) {
      let flag = $.fn.form.settings.rules.number(value);
      if (flag) {
        if (n) {
          let arr = n.split('..');
          let min = arr.length >= 1 ? Number(arr[0]) : Number.MIN_VALUE,
            max = arr.length >= 2 ? Number(arr[1]) : Number.MAX_VALUE,
            valNum = Number(value) && parseInt(value);
          return valNum >= min & valNum <= max;
        } else {
          return true;
        }
      }
      return false;
    };
    $.fn.form.settings.rules.dateCompareRule = dateCompareRule;

    let updateChallenge = function() {
      let fields = {};
      let challenge = {};
      fields['name'] = {
        rules: [
          {
            type: 'empty',
            prompt: $t('prompt.challenges.name.empty')
          }
        ]
      };
      fields['date-start'] = {
        rules: [
          {
            type: 'startDateRule',
            prompt: $t('prompt.challenges.date-start')
          }
        ]
      };
      fields['date-end'] = {
        rules: [
          {
            type: 'endDateRule',
            prompt: $t('prompt.challenges.date-end')
          }, {
            type: 'dateCompareRule',
            prompt: $t('prompt.challenges.time-end.compare')
          }
        ]
      };
      fields['input-hidden-dropdown-participation-status'] = {
        rules: [
          {
            type: 'participationStatusRule',
            prompt: $t('prompt.challenges.participation-status.empty')
          }
        ]
      };
      fields['input-hidden-dropdown-deviceTypes'] = {
        rules: [
          {
            type: 'deviceTypesRule',
            prompt: $t('prompt.challenges.device-types.empty')
          }
        ]
      };

      let weatherFields = {};

      weatherFields['homes'] = {
        rules: [
          {
            type: 'empty',
            prompt: $t('prompt.challenges.homes.empty')
          }, {
            type: 'percentageRule',
            prompt: $t('prompt.challenges.homes.invalid')
          }
        ]
      };
      weatherFields['latitude'] = {
        rules: [
          {
            type: 'empty',
            prompt: $t('prompt.challenges.homes.empty')
          }, {
            type: 'coordinates[-90..90]',
            prompt: $t('prompt.locations.latitude')
          }
        ]
      };
      weatherFields['longitude'] = {
        rules: [
          {
            type: 'empty',
            prompt: $t('prompt.challenges.homes.empty')
          }, {
            type: 'coordinates[-180..180]',
            prompt: $t('prompt.locations.longitude')
          }
        ]
      };

      $('#form-settings').form({
        inline: true,
        fields: fields
      });
      $('#form-weather').form({
        inline: true,
        fields: weatherFields
      });

      if ($('#form-settings').form('is valid') && $('#form-weath er').form('is valid')) {
        challenge.name = $scope.challenge.name;
        challenge.startDate = $scope.challenge.startDateMs;
        challenge.endDate = $scope.challenge.endDateMs;

        challenge.deviceTypeExistance = $scope.deviceTypeExistanceId;
        challenge.participantStatus = $scope.participantStatus;
        challenge.deviceTypes = $scope.selectedDeviceTypeIds;

        // Special parameters
        challenge.parameters = {};
        challenge.parameters.percent_relief = $scope.percentageHomes;
        challenge.parameters.simple = $scope.savingsLevel;
        challenge.parameters.latitude = $scope.latitude;
        challenge.parameters.longitude = $scope.longitude;

        if ($scope.participantTag && $scope.participantTag != '') {
          challenge.participantTag = $scope.participantTag;
        }
        if ($scope.excludeParticipantTag && $scope.excludeParticipantTag != '') {
          challenge.excludeParticipantTag = $scope.excludeParticipantTag;
        }
        if ($scope.selectedDeviceTypeIdsExclude && $scope.selectedDeviceTypeIdsExclude != null) {
          challenge.excludeDeviceTypes = $scope.selectedDeviceTypeIdsExclude;
        }

        // Otional parameters
        if ($scope.tempThreshold && $scope.tempThreshold != '') {
          challenge.parameters.temperature_threshold_c = $filter('F2C')($scope.tempThreshold);
        }
        if ($scope.humidityThreshold && $scope.humidityThreshold != '') {
          challenge.parameters.humidity_threshold = $scope.humidityThreshold;
        }
        if ($scope.indexThreshold && $scope.indexThreshold != '') {
          challenge.parameters.heatindex_threshold_c = $filter('F2C')($scope.indexThreshold);
        }

        // TODO: investigate
        //  Old code has a parameter: 'timeZone': utils.getBrowserTimezone()
        //  but server API docs has no data about such parameter
        return ChallengesService
          .updateChallenge($scope.orgInfo.id, $scope.challenge.challengeId, { 'challenge': challenge })
          .then(function(data) {
            let newChallenge = angular.merge($scope.challenge, challenge, {
              startDateMs: challenge.startDate,
              endDateMs: challenge.endDate
            });
            utils.setStorageItem('Selected-Challenge', newChallenge);
            ToastsService.success();
            return data;
          });
      }
    };

    $scope.saveChallenge = function(status) {
      if (status == 1) {
        $scope.changeStatus(1);
      }
      updateChallenge();
    };

    let getDeviceTypesPromise = DevicesService.getDeviceTypes();
    let getChallengePromise = ChallengesService.getChallenge($scope.orgInfo.id, $scope.challengeId);
    $q.all([getDeviceTypesPromise, getChallengePromise]).then(function(result) {
      let data0 = result[0];
      let data1 = result[1];
      if (data0.resultCode != 0 || data1.resultCode != 0) {
        return;
      }

      // Init Challenge
      $scope.challenge = data1.challenges[0];
      $scope.participantStatus = $scope.challenge.participantStatus;
      $scope.savingsLevel = $scope.challenge.parameters.simple;
      $scope.participantTag = $scope.challenge.participantTag;
      $scope.excludeParticipantTag = $scope.challenge.excludeParticipantTag;

      // Special parameters
      $scope.percentageHomes = $scope.challenge.parameters.percent_relief;
      $scope.latitude = $scope.challenge.parameters.latitude ? $scope.challenge.parameters.latitude : '';
      $scope.longitude = $scope.challenge.parameters.longitude;
      $scope.tempThreshold = $scope.challenge.parameters.temperature_threshold_c
        ? $filter('C2F')($scope.challenge.parameters.temperature_threshold_c)
        : '';
      $scope.humidityThreshold = $scope.challenge.parameters.humidity_threshold
        ? $scope.challenge.parameters.humidity_threshold
        : '';
      $scope.indexThreshold = $scope.challenge.parameters.heatindex_threshold_c
        ? $filter('C2F')($scope.challenge.parameters.heatindex_threshold_c)
        : '';

      // Radio buttons refreshing
      $scope.deviceTypeExistanceId = $scope.challenge.deviceTypeExistance;
      if ($scope.deviceTypeExistanceId != 0) {
        $('#typeExistanceRadioList .ui.radio.id-' + $scope.deviceTypeExistanceId).checkbox('check');
      }

      $scope.selectedDeviceTypeIds = $scope.challenge.deviceTypes;
      $scope.selectedDeviceTypeIdsExclude = $scope.challenge.excludeDeviceTypes;

      let deviceTypes = [];
      for (let type of data0.deviceTypes) {
        for (let typeId of $scope.selectedDeviceTypeIds) {
          if (typeId == type.id) {
            deviceTypes.push(type);
          }
        }
      }
      $scope.selectedDeviceTypeObjs = deviceTypes;
      $state.go('main.challenges.weather.more', {}, { location: false });

      // Init Device Types
      if ($scope.orgInfo.deviceTypes == null || $scope.orgInfo.deviceTypes == '') {
        $scope.deviceTypes = data0.deviceTypes;
      } else {
        let types = $scope.orgInfo.deviceTypes.split(',');
        $scope.deviceTypes = utils.convertKeysToItems(data0.deviceTypes, types, 'id');
      }

    });

  }
}

export default angular
  .module('main.challengesWeather.controller', [])
  .controller('ChallengesWeatherController', ChallengesWeatherController)
  .name;
